import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { toggleClass } from '../utils/dom'
import Scroll from '../services/Scroll'

export const STATES = {
    LIGHT: 'is-light',
    ACTIVE: 'is-active',
    SCROLLED: 'is-scrolled'
}

export default class HeaderTools extends Component {
    constructor(element) {
        super(element)

        this.state = {
            light: false,
            active: false,
            scrolled: false
        }

        this.leaveTimer = null
        this.enterTime = Date.now()
    }

    prepare() {
        EventBus.on('nav:open', this.handleNavOpen)
        EventBus.on('nav:close', this.handleNavClose)
        EventBus.on('section:enter', this.handleSectionEnter)
        EventBus.on('section:leave', this.handleSectionLeave)
        EventBus.on('swup:aftercontentchange', this.handleSwupContentChange)
        Scroll.on('scroll', this.handleScroll)
    }

    destroy() {
        EventBus.off('nav:open', this.handleNavOpen)
        EventBus.off('nav:close', this.handleNavClose)
        EventBus.off('section:enter', this.handleSectionEnter)
        EventBus.off('section:leave', this.handleSectionLeave)
        EventBus.off('swup:aftercontentchange', this.handleSwupContentChange)
        Scroll.off('scroll', this.handleScroll)
    }

    handleSwupContentChange = () => {
        this.state.light = false
        this.render()
    }

    handleSectionLeave = ({type, element}) => {
        clearTimeout(this.leaveTimer)
        if (this.enterTime < Date.now() - 100) {
            this.leaveTimer = setTimeout(() => {
                this.state.light = false
                this.render()
            }, 100)
        }
    }

    handleSectionEnter = ({type, element}) => {
        this.enterTime = Date.now()
        clearTimeout(this.leaveTimer)
        this.state.light = type === 'dark'
        this.render()
    }

    handleNavOpen = () => {
        this.state.active = true
        this.render()
    }

    handleNavClose = () => {
        this.state.active = false
        this.render()
    }

    handleScroll = ({ offset }) => {
        if (offset.y > 200 && !this.state.scrolled) {
            this.state.scrolled = true
            this.render()
        } else if (offset.y <= 200 && this.state.scrolled) {
            this.state.scrolled = false
            this.render()
        }
    }

    render() {
        toggleClass(this.element, STATES.LIGHT, this.state.light)
        toggleClass(this.element, STATES.ACTIVE, this.state.active)
        toggleClass(this.element, STATES.SCROLLED, this.state.scrolled)
    }

}